<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <b-button
        type="button"
        class="back-btn flex items-center ml-3 mb-4"
        @click="showCorporatebooking"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          @click="showCorporatebooking"
          svgClasses=""
        />
        Back
      </b-button>

      <div class="flex w-full justify-evenly">
        <div class="w-48">
          <b-form-group
            id="input-group-2"
            label="Company Name:"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="book_data.name"
              placeholder="Enter Company Name"
              required
            >
            </b-form-input>
          </b-form-group>
        </div>

        <div class="w-48">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-form-group
              id="input-group-1"
              label="Email :"
              label-for="input-1"
              description="we'll never share your email with anyone else."
            >
              <b-form-input
                id="input-1"
                v-model="book_data.email"
                type="email"
                placeholder="Enter email"
                required
              >
              </b-form-input>
            </b-form-group>
          </b-form>
        </div>
      </div>

      <div class="flex justify-evenly w-full">
        <div class="w-48">
          <b-form-group
            id="input-group-2"
            label="Enter Phone Number"
            label-for="input-2"
          >
            <b-form-input
              v-model="book_data.mobile"
              placeholder="Enter your number"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="w-48">
          <b-form-group label="Start Date:">
            <date-picker
              v-model="book_data.start"
              class="w-full"
              valueType="format"
            ></date-picker>
          </b-form-group>
        </div>
      </div>

      <div class="flex justify-evenly w-full">
        <!-- <div class="w-48">
          <b-form-group label="Start Date:">
            <date-picker
              v-model="book_data.start"
              class="w-full"
              valueType="format"
            ></date-picker>
          </b-form-group>
        </div> -->

        <!-- <div class="w-48">
          <b-form-group
            id="input-group-2"
            label="End Date:"
            label-for="input-2"
          >
            <date-picker
              v-model="book_data.endDate"
              class="w-full"
              valueType="format"
            ></date-picker>
          </b-form-group>
        </div> -->
      </div>

      <!-- 
      <label for="datepicker-valid">start date</label>
      <b-form-datepicker
        id="datepicker-valid"
        :state="true"
      ></b-form-datepicker> -->

      <!-- <div class="w-48 ml-3.5">
        <b-form-group id="input-group-3" label="status:" label-for="input-3">
          <b-form-select
            id="input-3"
            aria-placeholder="type"
            v-model="book_data.status"
            :options="status"
            required
          >
          </b-form-select>
        </b-form-group>
      </div> -->

      <b-button
        type="submit"
        variant="primary"
        class="mx-auto flex mb-12"
        @click="onSubmit()"
        >submit</b-button
      >
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        value: "",
        status: "type",
      },
      time1: null,
      time2: null,
      status: ["Active ", "Pending", "On Hold", "Cancel"],
      flatdate: null,
      show: true,
      mobileno: "",
      pageData: {},
      book_data: {},
    };
  },
  watch: {
    pageData(val) {
      this.book_data = { ...val };
    },
  },

  methods: {
    async onSubmit(event) {
      //   event.preventDefault();
      //   alert(JSON.stringify(this.form));

      let payload = {
        _id: this.book_data._id,
        name: this.book_data.name,
        email: this.book_data.email,
        mobile: this.book_data.mobile.toString(),
        start: this.book_data.start,
        status: this.book_data.status,
      };
      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "companydash/edit",
          payload
        );
        if (editData.code == 200) {
          this.$router.push({ name: "admin-dashboard" });
          this.$swal.fire({
            text: "Edit Successfully",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      } catch (err) {
        if (error) {
          loader.close();
        }
      }
    },

    showCorporatebooking() {
      this.$router.push({ name: "admin-dashboard" });
    },

    onReset(event) {
      event.preventDefault();
      this.form.name = "";
      this.form.email = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    async init() {
      // console.log(this.editdash);
      this.pageData = this.editdash;
    },
  },
  computed: {
    ...mapState("companydash", {
      editdash: "edit_dash",
    }),
    // computedData:{
    //     get(){
    //         return this.data.mobile
    //     }
    // },
  },
  mounted() {
    this.init();
  },
  components: {
    DatePicker,
  },
};
</script>

<style>
.mx-calendar-content .cell:hover {
  color: white;
  background-color: #6c0b6b;
}
.mx-calendar-content .cell.active {
  color: white;
  background-color: #6c0b6b;
}
.back-btn {
  border: 1px solid black;
  padding: 4px 19px;
}
.border-box {
  border: 1px solid #ddd;
}
.fsize20px {
  font-size: 20px;
}
.w-48 {
  width: 48%;
}
.input-b {
  width: 100%;
  padding: 7px 2px 10px 4px;
}
form-btn .mt-3rem {
  margin-top: 3rem;
}
.justify-evenly {
  justify-content: space-evenly;
}
.mx-datepicker {
  width: 100% !important;
}
</style>
